
import { defineComponent } from "vue";
import MiniModal from "@/components/layout/modals/MiniModal.vue";
import CustomButton from "@/components/inputs/customButton/CustomButton.vue";

export default defineComponent({
    name: "confirmDeleteModal",
    components: { MiniModal, CustomButton },
    props: {
        type: {
            type: String,
            required: false,
        },
        open: {
            type: Boolean,
            required: true,
        },
    },
    emits: ["close", "delete"],
});
